import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    redirect:'index'
  },
  {
    path: '/index',
    name:'index',
    component: () => import( '../views/home.vue')
  },
  {
    path: '/data',
    name:'data',
    component: () => import('../views/data.vue')
  },
  {
    path: '/comment',
    name:'comment',
    component: () => import('../views/comment.vue'),
  },
  {
    path:'/comment/pdf',component:()=>import('../components/commenttwo' )
  },
  {
    path: '/time_info',
    name:'time_info',
    component: () => import('../views/time_info.vue')
  },
  {
    path: '/enterprise',
    name:'enterprise',
    component: () => import('../views/enterprise.vue')
  },
  {
    path:'/enterprise/:id',component:()=>import('../components/enterprisetwo' )
  },
  {
    path:'/time_info/:id',component:()=>import('../components/time_infotwo' )
  },
  {
    path: '/aboutWe',
    name:'aboutWe',
    component: () => import('../views/aboutWe.vue')
  },
  {
    path: '/introduction',
    name:'introduction',
    component: () => import('../views/introduction.vue')
  },
]

const router = new VueRouter({
  routes,
})
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
export default router
